import { combineReducers } from 'redux';
import { value } from './value';
import { options } from './options';

export const drawerSystems = combineReducers( {
  value,
  options
} );

export function setDefaultDrawerSystems() {
  return ( dispatch, getStore ) => {
    const { calculationMode: { materialsFromDb } } = getStore();

    const options = materialsFromDb[ 'Drawer system' ];

    dispatch( {
      type: 'SET_CALCULATION_MODE_ADMIN_SETTINGS_DRAWER_SYSTEMS_OPTIONS',
      value: options
    } );

    dispatch( {
      type: 'SET_CALCULATION_MODE_ADMIN_SETTINGS_DRAWER_SYSTEMS_VALUE',
      value: options[ 0 ]
    } );
  };
}
